import { render, staticRenderFns } from "./canRuYuanGroupList.vue?vue&type=template&id=6934743c&scoped=true"
import script from "./canRuYuanGroupList.vue?vue&type=script&lang=js"
export * from "./canRuYuanGroupList.vue?vue&type=script&lang=js"
import style0 from "./canRuYuanGroupList.vue?vue&type=style&index=0&id=6934743c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6934743c",
  null
  
)

export default component.exports